<div class="modal-body content width-800 ">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{data?.title}}
    </span>
    <div class="content">
      <div class="layout-auto-1">
        <div>Sind Sie sicher, dass folgende {{(data.mode === 'QS') ? 'QS-' : ''}} Vorgänge an {{data?.DL.fullName}}
          disponiert werden sollen?
        </div>
        <div class="content">
          <ng-container *ngFor="let task of data?.tasks">
            <div class="list-row">
              <div class="list-row-auto-1">
                <div></div>
                <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                  <div class="list-metadata" style="margin-left:0">
                    <div>Auftraggeber: {{task.auAuftraggeberShort}} Schadenart: {{enumSvc.getEnumerationText(
                      'Schadenart',
                      task.aue_enmIdent_SchadenArt)}}</div>
                  </div>
                  <div class="list-metadata ">
                    <div
                      class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                  </div>
                  <div style="height: 30px">
                <span class="typo-center">
                  <span [tooltip]="'Nicht Geprüft'" flow="right">
                    <i class="fa-solid fa-xmark c-red" style="font-size: 14px" *ngIf="!task.vorgCKD"></i>
                  </span>
                  <span [tooltip]="'Geprüft'" flow="right">
                    <i class="fa-solid fa-check c-green" style="font-size: 14px" *ngIf="task.vorgCKD"></i>
                  </span>
                </span>
                    <span class="app-space-left">
                  <strong>{{task.vorgNr}}</strong> - {{task.aueSchadenNr}}
                </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="spawn-modal-actions typo-small">
      <div style="width: 100%" *ngIf="!(data.mode === 'QS')">
        <exg-checkbox [caption]="getTranslation('Auftragsannahme an Mandant senden')"
                      [(ngModel)]="sendCaseAcceptToClient"
                      class="md-check-reverse"></exg-checkbox>
      </div>
      <button (click)="cancel()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button (click)="send(true)" class="md-btn">
        Disponieren
      </button>
      <button *ngIf="!(data.mode === 'QS')" (click)="sendPreDispo(true)" class="md-btn">
        Vordisponieren
      </button>
    </div>
  </div>
</div>
